export const INSURANCE_ROUTES = [
  '/seguros',
  '/seguros/ofertas',
  '/seguros/autocontratacao-loja',
  '/seguros/autocontratacao-vida',
  '/seguros/autocontratacao-transacao',
  '/seguros/${id}/detalhes',
  '/seguros/${id}/detalhes/historico-cobranca',
  '/seguros/${id}/detalhes/beneficiarios',
  '/seguros/${id}/detalhes/cancelamento'
] as const
